import React, { useEffect, useState, memo } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  Modal,
  Form,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle
} from "@hello-pangea/dnd";
import Button from "@mui/material/Button";

import toPage from "../../assets/images/icons/console-control-1.svg";
import Delete from "../../assets/images/icons/whiteboard-menu-c-3.svg";
import edit from "../../assets/images/icons/whiteboard-menu-a-5.svg";
import dots from "../../assets/images/icons/whiteboard-menu-left-2.svg";
import layer from "../../assets/images/icons/whiteboard-menu-left-3.svg";
import trash from "../../assets/images/icons/console-control-3.svg";
import fullscreen from "../../assets/images/icons/whiteboard-menu-left-5.svg";
import fullscreenExit from "../../assets/images/icons/whiteboard-menu-left-6.svg";
import recycleBin from "../../assets/images/icons/console-control-3.svg";

import {
  getAuthToken
} from "../../utils/auth";

import { BoardInfo } from "../../store/screen/types";
import {
  BoardListGetAction,
  BoardElementListGetAction,
  BoardPageCopyAction,
  BoardPageUpdateAction,
  BoardPageDeleteAction,
  BoardLastPageAction,
} from "../../store/screen/actions";
import { screenState, setError } from "../../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { toggleFullscreen } from "../../utils/actions";

const BASE_URL = `${process.env.REACT_APP_API_URL}/elements/image/`;

interface Props {
  id: string;
  accessToken: string;
  dataList: any[];
  elementListGet: any;
}

const RecycleBin = ({ id, accessToken, dataList, elementListGet }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { errorMsg, success, boards, pageInfo, boardInfo } = useAppSelector(state => screenState(state));
  const [onReady, setOnReady] = useState(false);
  const [deleteList, setDeleteList] = useState([]);
  const [deleteType, setDeleteType] = useState("page");
  const [showDeleteType, setShowDeleteType] = useState(false);
  const [showDeleteList, setShowDeleteList] = useState(false);

  useEffect(() => {
    setOnReady(true);
  }, []);

  const toggleDeleteTypeModal = () => {
    setShowDeleteType(!showDeleteType);
  };

  const toggleDeleteListModal = () => {
    setShowDeleteList(!showDeleteList);
  };

  const DeleteTypeSet = (type: string, reload: any) => {
    const API_URL = process.env.REACT_APP_API_URL;
    const apiType = type === "page"? `boardPages/${id}` : `boardElements/${boardInfo?.id}`;
    const data = {
      "is_deleted": true
    };
    axios.post(`${API_URL}/api/${apiType}`, data, {
      headers: {
        'userToken': accessToken,
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      setDeleteList(response.data.data);
      if (!reload) {
        setDeleteType(type);
        toggleDeleteTypeModal();
        toggleDeleteListModal();
      }
    })
    .catch(error => {
      console.error('error:', error);
    });
  };

  const pageRecovery = (target: any) => {
    const API_URL = process.env.REACT_APP_API_URL;
    fetch(`${API_URL}/api/updatePages/${target.id}`, {
      method:"POST",
      headers: {
        "userToken": accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "background_id": target.background_id,
        "name": target.name as string,
        "content": target.content,
        "order_num": target.order_num,
        "is_restore": true
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status != "SUCCESS") {
        throw data;
      } else {
        DeleteTypeSet("page", true);
        const listGet = {
          id: id,
          pageNum: pageInfo.pageNum,
          is_deleted: false
        }
        dispatch(BoardListGetAction(listGet));
      }
    })
    .catch(e => {
      console.log("error", e);

      dispatch(setError("頁面更新失敗"));
    });
  };

  const componentRecovery = (target: any) => {
    const API_URL = process.env.REACT_APP_API_URL;
    const content = JSON.parse(target.content);
    content.id = "";
    content.idx = dataList.length;
    content.zIndex = dataList.length * 2;
    fetch(`${API_URL}/api/updateElements/${target.id}`, {
      method:"POST",
      headers: {
        "userToken": accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "type": target.type,
        "content": JSON.stringify(content),
        "is_restore": true
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status != "SUCCESS") {
        throw data;
      } else {
        DeleteTypeSet("component", true);
        if (boardInfo) {
          elementListGet({ id: boardInfo.id, is_deleted: false });
        }
      }
    })
    .catch(e => {
      console.log("error", e);

      dispatch(setError("元件更新失敗"));
    });
  };

  const componentTitleGet = (content: any) => {
    return JSON.parse(content).listTitle;
  };

  return (
    <React.Fragment>
      <button className="feature-anchor top-tool-btn drawhide-btn" onClick={() => toggleDeleteTypeModal()} data-tooltip-content="回收桶">
        <img src={recycleBin} style={{ width: "32px" }} alt="" />
      </button>
      <Modal id="deleteTypeModal" className="h-100 w-100 items-center justify-center sm:p-14 m-auto" isOpen={showDeleteType} toggle={toggleDeleteTypeModal} modalClassName="zoomIn" zIndex={1000120} centered>
        <Form
          onSubmit={e => {
            e.preventDefault();
            return false;
          }}
        >
          <div className="relative text-left overflow-y-auto overflow-x-hidden max-h-full w-full max-w-xs sm:max-w-3xl md:max-w-5xl">
            <div>
              <div className="deleteBox flex flex-col md:flex-row">
                <div className="deleteList">
                  <div className="deleteItem" onClick={() => DeleteTypeSet("page", false)}>
                    頁面
                  </div>
                  <div className="deleteItem" onClick={() => DeleteTypeSet("component", false)}>
                    元件
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <Modal id="deleteListModal" className={`h-100 w-100 items-center justify-center m-auto ${onReady? "layerReady" : ""}`} isOpen={showDeleteList} toggle={toggleDeleteListModal} modalClassName="zoomIn" zIndex={1000120} centered>
        <div className="w-100 mt-1 text-center"><label htmlFor="qr-code" className="crs-subtitle"> 垃圾桶 </label></div>
        {deleteType === "page"? (
          <div className="layerList pageList">
            {deleteList.map((item: any, index: number) => (
              <div className="layerItem" key={item.id}>
                <div className="layerTitle">
                  <div className="pageTitle">
                    {item.name}
                  </div>
                  <div className="pageImage">
                    <img src={BASE_URL + item.backgroundInfo.picture} alt="" />
                  </div>
                </div>
                <div className="pageDelete Recovery" onClick={() => pageRecovery(item)}>
                  <div>
                    <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                      <i className="mdi mdi mdi-recycle fs-24 fs-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {deleteType === "component"? (
          <div className="layerList RecoveList">
            {deleteList.map((item: any, index: number) => (
              <div className="layerItem" key={item.id}>
                <div className="layerTitle" data-num={`${index + 1}`}>
                  {componentTitleGet(item.content)}
                </div>
                <div className="layerLock">

                </div>
                <div className="pageDelete Recovery" onClick={() => componentRecovery(item)}>
                  <div>
                    <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                      <i className="mdi mdi mdi-recycle fs-24 fs-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </Modal>
    </React.Fragment>
  );
};

export default memo(RecycleBin);